function generateIdFromName(name) {
    return name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
}
export const productos = [
    {
        nombre: 'Prive Collection',
        descripcion: 'Categorías: Dim out, Blackout, Filtro Ligero',
        sePuedeMotorizar: true,
        img: require('../assets/img/prive-collection.png') 
    },{
        nombre: 'Pertina',
        descripcion: 'Tejidos: Rocks, Dimmer, Infinity',
        sePuedeMotorizar: true,
        img: require('../assets/img/imgPertina.jpg') 
    },{
        nombre: 'Persianas',
        descripcion: 'Cortinas: Sheer Elegance, sheer y enrollables, Panel Japones, Panel Japones',
        sePuedeMotorizar: false,
        img: require('../assets/img/productos/sheerElegance/miniaturasSheerElegance/muestra-img-4.jpg')
    },{
        nombre: 'Tejidos Exclusivos',
        descripcion: 'Yute, Tahiiti, Simetry, Montana, Lava, Gradiente, Forest, Brick...',
        sePuedeMotorizar: false,
        img: require('../assets/img/Australis-Beige.jpeg')
    },{
        nombre: 'Super Ofertas',
        descripcion: 'Ofertas en telas seleccionadas',
        sePuedeMotorizar: false,
        img: require('../assets/img/superOfertas.jpg')
    },{
        nombre: 'Telas para cortina y Confección',
        descripcion: 'Galaga, Lunet, Serenade, Sundown, Chifoffon, Gauze, Line...',
        sePuedeMotorizar: false,
        img: require('../assets/img/imgCortina.jpg')
    },{
        nombre: 'Lambrin',
        descripcion: 'Lambrín disponible en diferentes modelos y 3 medidas diferentes',
        sePuedeMotorizar: false,
        img: require('../assets/img/img-lambrin.png')
    },{
        nombre: 'Toldos',
        descripcion: 'Nuestra gama de modelos cubre gran variedad de situaciones donde lo esencial es protegerte..',
        sePuedeMotorizar: false,
        img: require('../assets/img/productos/toldos/palilleria.jpg')
    },{
        nombre: 'Telas Premium Vertilux',
        descripcion: 'La revolución de nuestras persianas enrollables',
        sePuedeMotorizar: false,
        img: require('../assets/img/productos/vertilux/vertiluxArcadia/muestra.jpg')
    }
].map(producto => ({
    ...producto,
    id: generateIdFromName(producto.nombre),
}));



export default productos
    




